// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../layout-and-structure/Stack.res.js";
import * as React from "react";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as InputTextField from "./InputTextField.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function ruleToReg(x) {
  switch (x) {
    case "MinStr":
      return /.{10,}.*/;
    case "MinLower":
      return /(.*[a-z]){1,}.*/;
    case "MinUpper":
      return /(.*[A-Z]){1,}.*/;
    case "MinDigit":
      return /(.*[0-9]){1,}.*/;
  }
}
function ruleToErrorMsg(x) {
  switch (x) {
    case "MinStr":
      return "At least 10 characters";
    case "MinLower":
      return "One lowercase letter";
    case "MinUpper":
      return "One uppercase letter";
    case "MinDigit":
      return "One digit";
  }
}
function applyRule(value, rule) {
  return ruleToReg(rule).test(value);
}
function InputPasswordField(props) {
  let __showTypingValidation = props.showTypingValidation;
  let value = props.value;
  let showTypingValidation = __showTypingValidation !== undefined ? __showTypingValidation : false;
  let match = React.useReducer((state, action) => {
    let textField = action._0;
    return {
      rules: state.rules.map(ruleState => {
        let rule = ruleState[1];
        let isValid = applyRule(textField, rule);
        return [isValid, rule];
      })
    };
  }, {
    rules: [[false, "MinStr"], [false, "MinLower"], [false, "MinUpper"], [false, "MinDigit"]]
  });
  let dispatch = match[1];
  React.useEffect(() => {
    dispatch({
      TAG: "FieldValueChanged",
      _0: value
    });
  }, [value]);
  let tmp;
  if (showTypingValidation) {
    let newrecord = {
      ...{
        className: "display-x78zum5 flexWrap-x1a02dak marginBottom-x16pr9af paddingTop-x1y1aw1k",
        "data-style-src": "wino-gc:src/resources/selection-and-input/InputPasswordField.res.js:12"
      }
    };
    tmp = JsxRuntime.jsx("div", (newrecord.children = match[0].rules.map((rule, index) => {
      let newrecord = {
        ...{
          className: "display-x78zum5 flexBasis-x4pfjvb",
          "data-style-src": "wino-gc:src/resources/selection-and-input/InputPasswordField.res.js:18"
        }
      };
      let newrecord$1 = {
        ...{
          className: "marginRight-x1bxrdft marginTop-x1gslohp",
          "data-style-src": "wino-gc:src/resources/selection-and-input/InputPasswordField.res.js:22"
        }
      };
      let newrecord$2 = {
        ...{
          className: "color-x1wohto9 font-xhhohpu",
          "data-style-src": "wino-gc:src/resources/selection-and-input/InputPasswordField.res.js:26"
        }
      };
      newrecord.children = [JsxRuntime.jsx("div", (newrecord$1.children = JsxRuntime.jsx(LegacyIcon.make, {
        name: "oval",
        fill: rule[0] ? "#1dbb7a" : "#e7e7ee"
      }), newrecord$1)), JsxRuntime.jsx("span", (newrecord$2.children = I18n.t(ruleToErrorMsg(rule[1])), newrecord$2))];
      return JsxRuntime.jsxs("div", newrecord, index.toString());
    }), newrecord));
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(Stack.make, {
    children: [JsxRuntime.jsx(InputTextField.make, {
      label: props.label,
      required: props.required,
      focused: props.focused,
      secureTextEntry: true,
      placeholder: props.placeholder,
      errorMessage: props.errorMessage,
      value: value,
      onChange: props.onChange,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }), tmp]
  });
}
let make = React.memo(InputPasswordField, (oldProps, newProps) => {
  if (oldProps.label === newProps.label && oldProps.errorMessage === newProps.errorMessage && oldProps.value === newProps.value && oldProps.focused === newProps.focused && oldProps.placeholder === newProps.placeholder) {
    return oldProps.onBlur === newProps.onBlur;
  } else {
    return false;
  }
});
let minStr = "MinStr";
let minLower = "MinLower";
let minUpper = "MinUpper";
let minDigit = "MinDigit";
export { applyRule, minStr, minLower, minUpper, minDigit, make };
/* styles Not a pure module */